/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from "@glimmer/component";
import type { EmberChangeset } from "ember-changeset";
import createAutoSaveChangeset from "parog-web/utils/create-auto-save-changeset";

import styles from "./index.module.css";

interface Signature {
  Element: HTMLDivElement;
  Args: {
    onDestroy?: unknown;
    title: string;
    model: EmberChangeset;
    index: number;
  };
}

export default class CoreAdministrativePatientDescendantComponent extends Component<Signature> {
  styles = styles;

  changeset: EmberChangeset;

  constructor(owner: unknown, args: Signature["Args"]) {
    super(owner, args);
    this.changeset = createAutoSaveChangeset(this.args.model);
  }

  get rank() {
    const rankNumber = this.args.index + 1;
    return rankNumber + (rankNumber === 1 ? "er" : "e");
  }
}
